import { Dialog } from "@headlessui/react";

import { CFC } from "shared/types";

type Props = {
  onClose: () => void;
  open: boolean;
};

export const SimpleModal: CFC<Props> = ({
  open,
  onClose,
  children,
}) => {
  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <div className="bg-black/40 fixed inset-0" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="h-max bg-white rounded-lg w-full max-w-md">
          {children}
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};
